<template lang="pug">
  .delivery-charges
    div
      v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-row.ma-0(align='center' justify='center' v-if="options.length == 0")
          div.mx-auto.text-center
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption {{ $t('no_rates_added') }}
        v-simple-table(v-else dense)
          thead
            tr
              th.pa-2 {{ $t('rate_description') }}
              th.pa-2 {{ $t('charge') }}
              th.text-center.pa-2 {{ $t('edit') }}
          tbody
            tr(v-for="(option, index) in options" :key="option.id")
              td.px-2
                div.text-caption {{ option.description }}
              td.px-2
                div.text-caption {{ rateValue(option) }}
              td.px-2
                v-layout.d-flex.justify-center
                  v-btn(icon @click="clickEditOption(option)")
                    eva-icon(name="edit-outline" height="32" fill='#231F20')
        v-divider
        y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

      v-row.pb-4.pt-2(no-gutters)
        v-col(align="left")
          v-btn(color="transparent" text x-small @click="clickAddOption")
            .button-Aa-medium.textColorAccent--text|+ {{ $t('add_rate') }}
    .modals
      update-delivery-charge(v-if="showUpdateOptionDialog" :open.sync="showUpdateOptionDialog" :company="company" :option="editingOption" :zone="zone" @added="handleAddItem" @edited="handleEditItem" @deleted="handleDeleteItem" :availableServices="availableServices")
</template>

<script>
import { mapActions } from 'vuex'
import UpdateDeliveryCharge from '@/components/dialogs/settings/UpdateDeliveryCharge.vue'

export default {
  name: 'DeliveryChargeList',
  components: { UpdateDeliveryCharge },
  props: ['company', 'zone'],
  data: () => ({
    isFetching: true,
    showUpdateOptionDialog: false,
    showDeleteOptionDialog: false,
    editingOption: null,
    deleteOption: null,
    options: [],
    pageSize: 10,
    page: 1,
    count: 0,
    isLoading: false,
    availableServices: [],
  }),
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchOptions(val)
      }
    }
  },
  mounted () {
    this.isFetching = true
    this.fetchServices()
    this.fetchOptions(1)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchOptions (page) {
      this.page = parseInt(page)
      this.isFetching = true
      this.$axios.get(`/shipping/settings/${this.company.slug}/manual_shippings/?page=${page}&page_size=${this.pageSize}&shipping_zone=${this.zone.id}&pickup=false&ordering=id`)
        .then((response) => {
          this.options = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchServices () {
      this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/courier`)
        .then((response) => {
          response.data.available_shipping.filter(f => f.enabled).forEach((service) => {
            this.availableServices.push(service)
          })
        })
        .catch(() => {})
      this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery`)
        .then((response) => {
          response.data.available_shipping.filter(f => f.enabled).forEach((service) => {
            this.availableServices.push(service)
          })
        })
        .catch(() => {})
    },
    clickAddOption () {
      this.editingOption = null
      this.showUpdateOptionDialog = true
    },
    clickEditOption (option) {
      this.editingOption = option
      this.showUpdateOptionDialog = true
    },
    handleDeleteItem(item) {
      this.options = this.options.filter((x) => x.id !== item)
    },
    handleAddItem (item) {
      this.options.push(item)
    },
    handleEditItem (item) {
      let opt = this.options.filter(f => f.id === item.id)
      opt[0].description = item.description
      opt[0].cod = item.cod
      opt[0].rate_type = item.rate_type
      opt[0].local_delivery = item.local_delivery
      opt[0].preferred_shipper = item.preferred_shipper
      opt[0].params = item.params
    },
    rateValue(rate) {
      switch(rate.rate_type){
        case 'flat':
          return `${this.$currency.symbol} ${(rate.params[0].rate/this.$currency.multiplier).toFixed(this.$currency.exponent)}`
        case 'weight':
          return 'By weight'
        //case 'distance':
        //  return ...
      }
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "no_rates_added": "No rates added yet",
    "rate_description": "Rate Description",
    "add_rate": "Add Rate"
  },
  "id": {
     "no_rates_added": "Belum ada tarif yang ditambahkan",
    "rate_description": "Rincian tarif",
    "add_rate": "Tambah tarif"
  }
}
</i18n>
